<script>
  import { 
    Zap, 
    BookOpen, 
    Settings, 
    Navigation, 
    Database, 
    Headphones, 
    Users, 
    AlertTriangle, 
    MessageCircle,
    ArrowLeft 
  } from '@lucide/svelte';
</script>

<div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-4xl mx-auto">
    <div class="bg-white shadow-lg rounded-lg overflow-hidden">
      <!-- Header -->
      <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-8">
        <h1 class="text-3xl font-bold text-white">Help & Documentation</h1>
        <!-- <p class="mt-2 text-blue-100">Everything you need to know about using the LDC Portal</p> -->
      </div>

      <!-- Content -->
      <div class="px-6 py-8">
        <!-- Quick Start Section -->
        <!-- <section class="mb-8">
          <h2 class="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
            <Zap class="w-6 h-6 text-blue-600 mr-2" />
            Quick Start Guide
          </h2>
          <div class="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-lg">
            <p class="text-gray-700">
              Welcome to the LDC Portal! This comprehensive guide will help you navigate through all the features and capabilities of our platform. Whether you're a new user or looking to explore advanced features, you'll find everything you need here.
            </p>
          </div>
        </section> -->

        <!-- Getting Started -->
        <section class="mb-8">
          <h2 class="text-2xl font-semibold text-gray-900 mb-4 flex justify-center">
            <!-- <div><BookOpen class="w-6 h-6 text-green-600 mr-2" /></div> -->
            <div>Getting Started</div>
          </h2>
          <div class="flex justify-around gap-6">
            <div class="bg-gray-50 p-6 rounded-lg">
              <h3 class="text-lg font-medium text-gray-900 mb-3 flex justify-center">
                <div><Settings class="w-5 h-5 text-gray-600 mr-2" /></div>
                <div>Account Setup</div>
              </h3>
              <p class="text-gray-600 mb-4">If you received an invitation email:</p>
              <ul class="text-sm text-gray-600 space-y-1">
                <li>• An account has been created with your email address.</li>
                <li>• Click the link in the email, and set your user name and password.</li>
                <li>• After setting your password, you'll be redirected to the sign in page.</li>
                <li>• Sign in using your email address (not your user name).</li>
                <li>• If you were added to a task, you'll see a Start Now link to begin working.  The link may say Continue if you've already started working and refreshed the page.</li>
                <li>• The UI will show a microphone that you need to grant access to, and it will then ask you to check the microphone levels without making a recording.</li>
                <li>• You will now see instructions on how to start the task and do the recordings.  You will first be asked to read the passage silently in your head, then to record and read it quickly, then record it eloquently.</li>
              </ul>
            </div>
            <!-- <div class="bg-gray-50 p-6 rounded-lg">
              <h3 class="text-lg font-medium text-gray-900 mb-3 flex items-center">
                <Navigation class="w-5 h-5 text-gray-600 mr-2" />
                Navigation
              </h3>
              <p class="text-gray-600 mb-4">Familiarize yourself with the interface layout, main navigation menus, and keyboard shortcuts to work more efficiently.</p>
              <ul class="text-sm text-gray-600 space-y-1">
                <li>• Dashboard overview</li>
                <li>• Menu navigation</li>
                <li>• Search functionality</li>
                <li>• Keyboard shortcuts</li>
              </ul>
            </div> -->
          </div>
        </section>

        <!-- Features -->
        <!-- <section class="mb-8">
          <h2 class="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
            <Settings class="w-6 h-6 text-purple-600 mr-2" />
            Core Features
          </h2>
          <div class="space-y-4">
            <div class="border border-gray-200 rounded-lg p-4">
              <h3 class="text-lg font-medium text-gray-900 mb-2 flex items-center">
                <Database class="w-5 h-5 text-blue-600 mr-2" />
                Data Management
              </h3>
              <p class="text-gray-600">Comprehensive tools for organizing, uploading, and managing your linguistic data files with advanced search and filtering capabilities.</p>
            </div>
            <div class="border border-gray-200 rounded-lg p-4">
              <h3 class="text-lg font-medium text-gray-900 mb-2 flex items-center">
                <Headphones class="w-5 h-5 text-green-600 mr-2" />
                Audio Processing
              </h3>
              <p class="text-gray-600">Advanced audio recording, playback, and analysis tools designed specifically for linguistic research and documentation.</p>
            </div>
            <div class="border border-gray-200 rounded-lg p-4">
              <h3 class="text-lg font-medium text-gray-900 mb-2 flex items-center">
                <Users class="w-5 h-5 text-purple-600 mr-2" />
                Collaboration Tools
              </h3>
              <p class="text-gray-600">Share projects, manage team access, and collaborate in real-time with researchers and team members worldwide.</p>
            </div>
          </div>
        </section>
 -->
        <!-- Troubleshooting -->
        <!-- <section class="mb-8">
          <h2 class="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
            <AlertTriangle class="w-6 h-6 text-red-600 mr-2" />
            Troubleshooting
          </h2>
          <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p class="text-gray-700 mb-4">
              Having issues? Check out our comprehensive troubleshooting guide covering the most common problems and their solutions.
            </p>
            <div class="grid md:grid-cols-3 gap-4 text-sm">
              <div>
                <h4 class="font-medium text-gray-900 mb-2">Login Issues</h4>
                <p class="text-gray-600">Password reset, account activation, and authentication problems.</p>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-2">File Upload</h4>
                <p class="text-gray-600">Supported formats, size limits, and upload error resolution.</p>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-2">Browser Compatibility</h4>
                <p class="text-gray-600">Recommended browsers, settings, and plugin requirements.</p>
              </div>
            </div>
          </div>
        </section> -->

        <!-- Contact Support -->
        <!-- <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
            <MessageCircle class="w-6 h-6 text-indigo-600 mr-2" />
            Contact Support
          </h2>
          <div class="bg-indigo-50 border border-indigo-200 rounded-lg p-6">
            <p class="text-gray-700 mb-4">
              Need additional help? Our support team is here to assist you with any questions or technical issues you may encounter.
            </p>
            <div class="grid md:grid-cols-2 gap-4">
              <div>
                <h4 class="font-medium text-gray-900 mb-2">Email Support</h4>
                <p class="text-sm text-gray-600">Send us an email and we'll respond within 24 hours during business days.</p>
                <p class="text-sm text-indigo-600 font-medium mt-1">support@ldcportal.org</p>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-2">Documentation</h4>
                <p class="text-sm text-gray-600">Explore our comprehensive documentation and API reference guides.</p>
                <p class="text-sm text-indigo-600 font-medium mt-1">docs.ldcportal.org</p>
              </div>
            </div>
          </div>
        </section> -->
      </div>

      <!-- Footer -->
      <div class="bg-gray-50 px-6 py-4 border-t border-gray-200">
        <div class="flex items-center justify-between">
          <p class="text-sm text-gray-500">Last updated: September 2025</p>
          <div class="flex space-x-4">
            <a href="/" class="text-sm text-indigo-600 hover:text-indigo-500 font-medium flex items-center">
              <ArrowLeft class="w-4 h-4 mr-1" />
              Back to Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>